<template>
  <section
    id="device-list"
    style="width: 100vw;
            height: 100vh !important;
            padding: 0px !important;
            margin: 0px !important;
            top: 0px !important;
            left: 0px !important;
            position: absolute;z-index: 9;"
  >
    <PreLoaderSpinner v-if="firstLoaded()" />
    <b-card>
      <b-card-body style="height: 100%; padding-top: 0">
        <b-button
          class="btn btn-success addDeviceBtn"
          @click="onAddDeviceClick()"
        >
          <feather-icon
            icon="PlusIcon"
            size="18"
          />
          ثبت دستگاه جدید
        </b-button>
        <b-form-input
          v-model="searchQuery"
          style="width: 100%"
          placeholder="جستجو..."
        />

        <app-collapse>
          <app-collapse-item
            title="ردیاب های من"
            style="color: #fff;"
          >
            <div
              id="devicesArea"
              style="margin-bottom: 40px;"
            >
              <v-radio-group v-model="selectedDevice">
                <div
                  v-for="device in resultQuery"
                  :selected="device.imei==selectedDevice"
                  class="deviceRow"
                >
                  <v-menu
                    v-if="device.imei==selectedDevice"
                    offset-y
                    style="display: block;"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        style="float: left;margin-top: -5px;margin-left:0px;color: white;background: #fff0;"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon
                          size="18"
                        >mdi-format-list-bulleted</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(item, index) in items"
                        :key="index"
                        @click="onEditItem(item.action, device)"
                      >
                        <v-icon
                          size="15"
                          style="padding-left:5px "
                        >
                          {{ item.icon }}
                        </v-icon>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-radio
                    name="deviceImeiFilter"
                    :value="device.imei"
                    style="float: right;margin-left: 7px;"
                    @click="selectDevice(device.imei)"
                  />
                  <span
                    style="font-size: 14px"
                    @click="selectDevice(device.imei)"
                  >{{ device.title }}</span>
                  <div :style="[device.imei==selectedDevice ? {'display': 'inline-block','margin': '10px 0','direction': 'ltr'} : {'direction': 'ltr'}]">
                    <span
                      class="col-4"
                      style="font-size: 9px;display: ruby;"
                    >
                      <v-icon
                        size="12"
                        color="rgb(40, 199, 106)"
                      >mdi-unity</v-icon>
                      {{ device.modelId.title }}
                    </span>
                    <span
                      class="col-4"
                      style="font-size: 9px"
                    >
                      <v-icon
                        size="12"
                        color="rgb(40, 199, 106)"
                      >mdi-sim</v-icon>
                      {{ device.sim }}
                    </span>
                    <span
                      class="col-4"
                      style="margin-top: 2px; font-size: 9px; padding-right: 2px"
                    >
                      <v-icon
                        color="rgb(40, 199, 106)"
                        small
                      >mdi-blur</v-icon>
                      {{ device.imei }}
                    </span>
                  </div>
                  <div style="display: block;">
                    <div style="margin-top: 2px; font-size: 10px; padding-right: 8px;display: inline;">
                      <span :class="getDeviceOnlineStatusCssClass(device.imei)" /> {{ sinceFrom(getFixDeviceInfo(device).serverInfo.servertime) }}
                    </div>
                    <div style="float: left;font-size: 10px;">
                      <span v-if="getDeviceSpeed(device.imei)"> {{ ' ( '+ getDeviceSpeed(device.imei) + ' کیلومتر برساعت )' }} </span>
                      <span v-else> متوقف </span>
                    </div>
                  </div>

                  <div
                    v-if="device.imei==selectedDevice"
                    style="display: block; display: block;
                            border-top: 1px solid rgb(17, 68, 60);
                            padding-top: 0px;
                            margin-top: 5px;
                            background: rgb(0, 92, 77) none repeat scroll 0% 0%;
                            border-radius: 5px;display: flex;"
                  >
                    <span
                      class="col-4"
                      style="font-size: 10px;padding-left: 0px;padding-right: 0px;text-align: center;"
                      @click="dashboard"
                    >
                      <v-icon
                        size="16"
                        color="#fff"
                      >mdi-view-dashboard</v-icon>

                      داشبورد
                    </span>
                    <span
                      class="col-4"
                      style="font-size: 10px;padding-left: 0px;padding-right: 0px;text-align: center;"
                      @click="monitor"
                    >
                      <feather-icon
                        icon="MapIcon"
                        size="16"
                      />{{ }}
                      مانیتورینگ
                    </span>
                    <span
                      class="col-4"
                      style="font-size: 10px;padding-left: 0px;padding-right: 0px;text-align: center;"
                      @click="history"
                    >
                      <feather-icon
                        icon="ZapIcon"
                        size="16"
                      />{{ }}
                      سابقه حرکت
                    </span>
                  </div>
                </div>
              </v-radio-group>
            </div>
          </app-collapse-item>
        </app-collapse>
        <b-modal
          ref="modal-change-sim"
          cancel-variant="outline-secondary"
          ok-title="ذخیره"
          cancel-title="بستن"
          centered
          title="تغییر سیمکارت دستگاه"
        >
          <b-form>
            <b-form-group
              label="شماره سیمکارت فعلی"
              label-for="v-Sim"
            >
              <b-form-input
                id="v-Sim"
                v-model="device.sim"
                class="numeric-input"
                maxlength="11"
                disabled
              />
            </b-form-group>
            <b-form-group
              label="شماره سیمکارت جدید"
              label-for="v-Sim"
            >
              <b-form-input
                id="v-SimN"
                v-model="simIdSelected"
                placeholder="09xxxxxxxxx"
                maxlength="11"
                class="numeric-input"
              />
            </b-form-group>
          </b-form>
          <template #modal-footer="">
            <b-button
              size="sm"
              variant="danger"
              @click="hideModal('modal-change-sim')"
            >
              بستن
            </b-button>
            <b-button
              size="sm"
              variant="success"
              @click="modalChangeSim()"
            >
              ذخیره
            </b-button>
          </template>
        </b-modal>

        <b-modal
          ref="modal-change-name"
          cancel-variant="outline-secondary"
          ok-title="ذخیره"
          cancel-title="بستن"
          centered
          title="تغییر نام خودرو"
        >
          <b-form>
            <b-form-group
              label="نام فعلی"
              label-for="v-title"
            >
              <b-form-input
                id="v-title"
                v-model="device.title"
                disabled
              />
            </b-form-group>
            <b-form-group
              label="نام جدید"
              label-for="v-Sim"
            >
              <b-form-input
                id="v-Sim"
                v-model="newtitle"
                maxlength="100"
              />
            </b-form-group>
          </b-form>
          <template #modal-footer="">
            <b-button
              size="sm"
              variant="danger"
              @click="hideModal('modal-change-name')"
            >
              بستن
            </b-button>
            <b-button
              size="sm"
              variant="success"
              @click="modalChangeTitle()"
            >
              ذخیره
            </b-button>
          </template>
        </b-modal>

        <b-modal
          ref="modal-change-category"
          cancel-variant="outline-secondary"
          ok-title="ذخیره"
          cancel-title="بستن"
          centered
          title="تغییر نوع خودرو"
        >
          <b-form>
            <b-form-group
              label="نوع وسیله نقلیه"
              label-for="v-address"
            >

              <b-form-select
                v-model="device.category"
                :select-size="6"
              >
                <b-form-select-option
                  v-for="option in options"
                  :key="option.value"
                  :value="option.value"
                >
                  <div>
                    <v-icon
                      size="30"
                      color="#777"
                    > {{ option.icon }}</v-icon>
                    {{ option.text }}
                  </div>
                </b-form-select-option>
              </b-form-select>

            </b-form-group>
          </b-form>
          <template #modal-footer="">
            <b-button
              size="sm"
              variant="danger"
              @click="hideModal('modal-change-category')"
            >
              بستن
            </b-button>
            <b-button
              size="sm"
              variant="success"
              @click="modalChangeCategory()"
            >
              ذخیره
            </b-button>
          </template>
        </b-modal>

        <b-modal
          ref="modal-send-sms"
          cancel-variant="outline-secondary"
          ok-title="ذخیره"
          cancel-title="بستن"
          centered
          title="ارسال تنظیمات سرور"
        >
          <p>برای تنظیم ردیاب خود، دستور زیر را به سیمکارت با شماره
            {{ device.sim }}
            پیامک کنید</p>
          <code>{{ smsconfigtext }}</code>
          <br>
          <br>
          <b-button
            size="sm"
            variant="success"
            @click="modalSendSms()"
          >
            ارسال پیامک
          </b-button>
          <template #modal-footer="">
            <b-button
              size="sm"
              variant="danger"
              @click="hideModal('modal-send-sms')"
            >
              بستن
            </b-button>
          </template>
        </b-modal>
      </b-card-body>
    </b-card>
  </section>
</template>
<script>
import PreLoaderSpinner from '@core/components/pre-loader-spinner/PreLoaderSpinner.vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import {
  BCard, BCardBody, BButton, BFormInput, BFormGroup, BForm, BFormSelect, BFormSelectOption,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Vue from 'vue'
import router from '@/router'
import Device from '@/models/device'
// eslint-disable-next-line import/no-named-as-default
import DeviceService from '@/services/device.service'
import Config from '../../../config'
import UserService from '@/services/user.service'

Vue.prototype.$pagesInitializeData.DeviceListVue = { firstLoaded: true }

export default {
  components: {
    BForm,
    BFormGroup,
    BFormSelect,
    BFormSelectOption,
    BCard,
    BCardBody,
    BButton,
    BFormInput,
    PreLoaderSpinner,
    AppCollapse,
    AppCollapseItem,
  },
  data() {
    return {
      items: [
        { title: 'تغییر نام خودرو', icon: 'mdi-account-edit', action: 'modal-change-name' },
        { title: 'تغییر نوع خودرو', icon: 'mdi-car', action: 'modal-change-category' },
        { title: 'تغییر سیمکارت', icon: 'mdi-sim-alert', action: 'modal-change-sim' },
        { title: 'ارسال تنظیمات سرور', icon: 'mdi-apple-keyboard-shift', action: 'modal-send-sms' },
      ],
      device: new Device('', '', '', '', '', '', '', '', '', ''),
      devices: [],
      desserts: [],
      devicesOnlineStatus: {},
      selectedDevice: null,
      searchQuery: '',
      simIdSelected: '',
      newtitle: '',
      smsconfigtext: 'SERVER,0,s1.4-rah.com,4000,0#',
      options: Config.carTypes,
    }
  },
  computed: {
    resultQuery() {
      const devices = Vue.prototype.$functions.searchInDevices(this.searchQuery)
      this.checkSelectedDevices()
      return devices
    },
  },
  mounted() {
    window.addEventListener('resize', () => {
      if (!this.$functions.isMobile()) {
        this.$router.push('/')
      }
    })
    this.$root.$on('forceUpdate', () => {
      this.$forceUpdate()
    })
  },
  created() {
    // eslint-disable-next-line no-unused-expressions,no-sequences
    this.QXUpdateFirebaseData(),
    this.doFillDevices(),
    this.checkMobileView(),
    this.checkSelectedDevices(),
    this.checkOnlineStatus()
  },
  mutations: {
    onDeleteItem(state, payload) {
      state.items.splice(payload, 1)
      // eslint-disable-next-line no-underscore-dangle
    },
  },
  methods: {
    firstLoaded() {
      return Vue.prototype.$pagesInitializeData.DeviceListVue.firstLoaded
    },
    QXUpdateFirebaseData() {
      UserService.updateFirebaseDataIfNeeded({})
    },
    select(option) {
      // console.log(option)
      this.selected = option
    },
    doFillDevices() {
      Vue.prototype.$functions.fillDevices().then(() => {
        this.searchQuery = ' '
        this.searchQuery = ''
        this.checkSelectedDevices()
        PreLoaderSpinner.methods.hide()
        Vue.prototype.$pagesInitializeData.DeviceListVue.firstLoaded = false
      }).catch(() => {
        PreLoaderSpinner.methods.hide()
        Vue.prototype.$pagesInitializeData.DeviceListVue.firstLoaded = false
      })
    },
    getFixDeviceInfo(device) {
      return Vue.prototype.$functions.fixDeviceInfo(device)
    },
    getDeviceSpeed(imei) {
      if ('speed' in Vue.prototype.$devices[Vue.prototype.$functions.getDeviceIndex(imei)]) {
        return Vue.prototype.$devices[Vue.prototype.$functions.getDeviceIndex(imei)].speed
      }
      return false
    },
    getDeviceOnlineStatusCssClass(imei) {
      return Vue.prototype.$devices[Vue.prototype.$functions.getDeviceIndex(imei)].onlineStatus
    },
    sinceFrom(unixTime) {
      if (unixTime < 1000) {
        return 'مدتی پیش'
      }
      const time = Vue.prototype.$functions.time()
      return this.$functions.timeSince(unixTime > time ? time : unixTime)
    },
    checkMobileView() {
      if (!this.$functions.isMobile()) {
        this.$router.push('/')
      }
    },
    selectDevice(imei) {
      this.selectedDevice = imei
      this.updateSelectedDevices()
    },
    checkSelectedDevices() {
      if (Vue.prototype.$mobileSelectedDevices.length > 0) {
        this.selectedDevice = Vue.prototype.$mobileSelectedDevices[0]
      }
    },
    updateSelectedDevices() {
      if (this.selectedDevice) {
        Vue.prototype.$functions.setMobileSelectedDevices([this.selectedDevice])
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'پیام',
            text: 'دستگاه انتخابی ذخیره شد.',
            icon: 'XIcon',
            variant: 'success',
          },
        })
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'پیام',
            text: 'حداقل یک دستگاه انتخاب کنید.',
            icon: 'XIcon',
            variant: 'danger',
          },
        })
      }
    },
    checkOnlineStatus() {
      clearInterval(Vue.prototype.$timer)
      Vue.prototype.$timer = setInterval(() => {
        this.$socket.emit('devicesOnlineTime', {})
      }, 20000)
    },
    onAddDeviceClick() {
      router.push({ name: 'device-add' })
    },
    dashboard() {
      router.push({ name: 'device-dashboard' })
    },
    monitor() {
      router.push({ name: 'home' })
    },
    history() {
      router.push({ name: 'home', params: { action: 'history' } })
    },
    modalChangeSim() {
      // eslint-disable-next-line no-underscore-dangle,radix
      DeviceService.changeSim({ imei: parseInt(this.device.imei), sim: this.simIdSelected }).then(
        res => {
          if (res.status === 'success') {
            this.$refs['modal-change-sim'].hide()
            this.doFillDevices()
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    modalSendSms() {
      if (Vue.prototype.$productionPlatform === 'ios') {
        window.location.href = `sms://${this.device.sim}&body=${this.smsconfigtext}`
      } else if (Vue.prototype.$productionPlatform === 'android') {
        window.location.href = `sms:${this.device.sim}?body=${this.smsconfigtext}`
      //  window.location.href = `http://127.0.0.1:3232/QXNative/?action=openSmsManager&to=${this.device.sim}&body=${encodeURIComponent(this.smsconfigtext)}`
      }
    },
    modalChangeTitle() {
      // eslint-disable-next-line no-underscore-dangle,radix
      DeviceService.changeTitle({ imei: parseInt(this.device.imei), title: this.newtitle, category: this.device.category }).then(
        res => {
          if (res.status === 'success') {
            this.$refs['modal-change-name'].hide()
            this.doFillDevices()
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    modalChangeCategory() {
      // eslint-disable-next-line no-underscore-dangle,radix
      DeviceService.changeTitle({ imei: parseInt(this.device.imei), title: this.device.title, category: this.device.category }).then(
        res => {
          if (res.status === 'success') {
            this.$refs['modal-change-category'].hide()
            this.doFillDevices()
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    onEditItem(action, item) {
      if (action === 'modal-change-sim') {
        this.device.sim = item.sim.toString()
        this.device.imei = item.imei.toString()
        // eslint-disable-next-line no-underscore-dangle
        this.device.modelId = item.modelId._id.toString()
        this.$refs['modal-change-sim'].show()
      }
      if (action === 'modal-change-name') {
        this.device.title = item.title.toString()
        this.device.category = item.category
        this.device.imei = item.imei.toString()
        // eslint-disable-next-line no-underscore-dangle
        this.device.modelId = item.modelId._id.toString()
        this.$refs['modal-change-name'].show()
      }
      if (action === 'modal-change-category') {
        this.device.title = item.title.toString()
        this.device.category = item.category
        this.device.imei = item.imei.toString()
        // eslint-disable-next-line no-underscore-dangle
        this.device.modelId = item.modelId._id.toString()
        this.$refs['modal-change-category'].show()
      }
      if (action === 'modal-send-sms') {
        this.device.sim = item.sim
        this.device.title = item.title.toString()
        this.device.imei = item.imei.toString()
        // eslint-disable-next-line no-underscore-dangle
        this.device.modelId = item.modelId._id.toString()
        this.$refs['modal-send-sms'].show()
      }
    },
    hideModal(id) {
      this.$refs[id].hide()
    },
  },
}
</script>
<style>
#device-list {
  background-color: #232633;
}
#device-list .card, #device-list .card-body {
  background-color: #232633;
  border-radius: 0;
}

#device-list .deviceRow {
  margin-bottom: 4px; width: 100%;
  padding: 5px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
  border-radius: 5px;
 /* cursor: pointer;*/
  margin-bottom: 7px;
  background: #343848;
  color: #fff;
}
#device-list .deviceRow[selected='selected']{
  background-color: #4f5362;
}
#device-list .deviceRow:hover {
  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
}
#device-list .card-body {
  padding-right: 0.2rem !important;
  padding-left: 0.2rem !important;
}
.onlineSymbol, .offlineSymbol {
  height: 7px;
  width: 7px;
  border-radius: 50%;
  display: inline-block;
}

.onlineSymbol {
  background-color: green;
  border: 1px solid;
}

.offlineSymbol {
  background-color: red;
  border: 1px solid;
}

.v-messages {
  min-height: 0;
}

[dir=rtl] #device-list .addDeviceBtn {
  position: fixed;
  bottom: 60px;
  z-index: 999;
  /*width: 100%;*/
  margin-top: 5px;
}
[dir=rtl] #device-list .card-header{
  padding-bottom: 0;
}
</style>
